import { withDependencies } from '@wix/thunderbolt-ioc'
import type { IRouter, ICurrentRouteInfo, IPageRouteChangedHandler, CandidateRouteInfo } from '../types'
import { CurrentRouteInfoSymbol } from '@wix/thunderbolt-symbols'
import { Router, name, RouterContextSymbol } from '../symbols'
import { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { IRouterContext } from '../types'

export const PageRouteChangedHandler = withDependencies(
	[CurrentRouteInfoSymbol, Router, RouterContextSymbol],
	(
		currentRouteInfo: ICurrentRouteInfo,
		router: IRouter,
		routerContext: IRouterContext
	): IModelUpdatesHandlersImplementor<IPageRouteChangedHandler> => {
		return {
			featureName: name,
			handlers: {
				onPageRouteChange: ({ route, url }) => {
					const currentRoute = currentRouteInfo.getCurrentRouteInfo() as CandidateRouteInfo
					const isUrlChanged =
						currentRoute && currentRoute.pageId === route.pageId && currentRoute.relativeUrl !== url
					if (isUrlChanged) {
						const routeInfo = router.buildRouteInfo(url) as CandidateRouteInfo
						routeInfo.contextId = routerContext.getRouteInfoContext(routeInfo as CandidateRouteInfo)
						currentRouteInfo.updateCurrentRouteInfo(routeInfo)
					}
				},
			},
		}
	}
)
